export default "__VITE_ASSET__C4YCF0Xp__"